import { render, staticRenderFns } from "./dynamic-discount-modal.vue?vue&type=template&id=32cf282f"
import script from "./dynamic-discount-modal.vue?vue&type=script&lang=js"
export * from "./dynamic-discount-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports